import React from "react";
import { Col, Row } from "antd";
import { observer } from "mobx-react";
import {IDepartmentsSummary} from "../../../declarants/Interfaces";
import DepartmentsSummary from "./departmentsSummary";

interface Props {
  store: IDepartmentsSummary;
}

const GUTTER = 15;

const Summary: React.FC<Props> = ({ store }) => {
  return (
    <Row gutter={GUTTER} justify="end" align="bottom">
      <Col>
        <Row gutter={GUTTER}>
          <Col>
            <div className="summary-rows">
              <p>&nbsp;</p>
              <p key="general-title">General:</p>
              <p key="selected-title">Selected:</p>
            </div>
          </Col>
          <DepartmentsSummary store={store} gutter={GUTTER} />
        </Row>
      </Col>
    </Row>
  );
};

export default observer(Summary);
